import React from "react";

const principles = [
  {
    n: "01",
    t: "Compute belongs where the sound is made.",
    d: "Inference should live on the module, not in the cloud. A constrained footprint forces honest models, and latency, privacy, and reliability all improve when the round-trip disappears.",
  },
  {
    n: "02",
    t: "Measure the model like a circuit.",
    d: "Every model went through the same bench as the hardware: power draw, latency distribution, worst-case heat, noise floor at the outputs. No performance claims by vibe.",
  },
  {
    n: "03",
    t: "Document for the future reader.",
    d: "Schematics, firmware, and model weights all age. Each module ships with its service sheet • BOM, test points, calibration procedure • so it's still serviceable a decade from now.",
  },
];

const PhilosophySection = () => {
  return (
    <section className="relative bg-lab-ink text-lab-paper border-t border-lab-rule">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-6 pb-10 border-b border-lab-rule-strong">
          <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
            <div>§ 04</div>
          </div>
          <div className="col-span-12 md:col-span-10">
            <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tightest text-lab-paper leading-none">
              Working principles.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3">
          {principles.map((p) => (
            <div
              key={p.n}
              className="border-t border-lab-rule md:border-t-0 md:border-l first:border-l-0 p-6 md:p-8"
            >
              <div className="font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim mb-6">
                {p.n}
              </div>
              <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight text-lab-paper mb-3 leading-snug">
                {p.t}
              </h3>
              <p className="text-sm md:text-base text-lab-paper-dim leading-relaxed">
                {p.d}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-lab-rule pt-4 flex flex-wrap gap-x-8 gap-y-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
          <span className="text-lab-paper">TOOLING</span>
          <span>KiCad</span>
          <span>STM32</span>
          <span>Embedded C</span>
          <span>TensorFlow Lite Micro</span>
          <span>Python</span>
          <span>DSP</span>
          <span>PCB</span>
          <span>Panel CNC</span>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
